import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ca06e4cc&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca06e4cc')) {
      api.createRecord('ca06e4cc', component.options)
    } else {
      api.reload('ca06e4cc', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ca06e4cc&", function () {
      api.rerender('ca06e4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LMIX710iBt7z/JS/videoIframe.vue"
export default component.exports